export function DotsPattern({
    className,
    style,
    width = "100%",
    height = "100%",
    dotSize = 2,
    gapSize = 2,
}: {
    className?: string
    style?: React.CSSProperties
    width?: number | string
    height?: number | string
    patternWidth?: number
    patternHeight?: number
    dotSize?: number
    gapSize?: number
}) {
    const patternId = "dots-pattern"
    const filterId = "dots-filter"
    const maskId = "dots-mask"

    const patternSize = dotSize + gapSize

    return (
        <svg
            className={className}
            style={style}
            width={width}
            height={height}
            aria-hidden="true"
        >
            <defs>
                <filter id={filterId}>
                    <feTurbulence
                        type="fractalNoise"
                        baseFrequency={1 / (patternSize * 1.5)}
                        numOctaves="1"
                        stitchTiles="stitch"
                    />
                    <feComponentTransfer>
                        <feFuncA type="linear" slope="0.15" intercept="0" />
                    </feComponentTransfer>
                </filter>
                <pattern
                    id={patternId}
                    width={patternSize}
                    height={patternSize}
                    patternUnits="userSpaceOnUse"
                >
                    <rect width={dotSize} height={dotSize} fill="white" />
                </pattern>
                <mask id={maskId}>
                    <rect
                        width="100%"
                        height="100%"
                        fill={`url(#${patternId})`}
                    />
                </mask>
            </defs>
            <rect
                width="100%"
                height="100%"
                fill="white"
                filter={`url(#${filterId})`}
                mask={`url(#${maskId})`}
            />
        </svg>
    )
}
